import { ProductDetailsPage } from "@decocms/apps-commerce/types"
import Image from "~/components/ui/Image"

export interface Props {
    /** @title Integração */
    page: ProductDetailsPage | null

    layout: {
        /**
         * @title Largura
         */
        width: number
        /**
         * @title Altura
         */
        height: number
    }
}

/**
 * @title Imagem Frontal e Traseira do Produto
 * @description Renderiza duas imagens lado a lado, tanto no celular quanto na área de trabalho. No celular, é adicionado uma barra de rolagem horizontal para que o usuário possa visualizar as duas imagens.
 */
function GalleryFrontBack(props: Props) {
    if (props.page === null) {
        throw new Error('Missing Product Details Page Info')
    }

    const {
        page: {
            product: { image: images = [] },
        },
        layout: { width, height },
    } = props
    const aspectRatio = `${width} / ${height}`

    return (
        <ul className='carousel carousel-center gap-6'>
            {images !== null &&
                [images[0], images[1] ?? images[0]].map((img, index) => (
                    <li className='carousel-item'>
                        <Image
                            className='w-screen sm:w-[24vw]'
                            sizes='(max-width: 640px) 100vw, 24vw'
                            style={{ aspectRatio }}
                            src={img.url!}
                            alt={img.alternateName}
                            width={width}
                            height={height}
                            // Preload LCP image for better web vitals
                            preload={index === 0}
                            loading={index === 0 ? 'eager' : 'lazy'}
                        />
                    </li>
                ))}
        </ul>
    )
}

export default GalleryFrontBack
